import {inject} from '@angular/core';
import {I18nService} from '@shared/services/i18n.service';
import {AuthService} from '@shared/services/auth.service';
import {ELanguageLabel} from '@shared/enums/language';
import {TLanguage} from '@shared/interfaces/language';
import {EQueryParam} from '@shared/enums/query-param';
import {EEndpointApp} from '@shared/enums/endpoint-app.enum';
import {Router} from '@angular/router';
import {lastValueFrom} from 'rxjs';
import {IAuth} from '@shared/interfaces/auth';

export const fnAppInitializerFactory = () => {
  const i18n = inject(I18nService);

  const all = [i18n.appendTranslations(ELanguageLabel.EN)];

  const {qToken, referer, qLang} = getParam();

  if (qLang && qLang.toUpperCase() in ELanguageLabel && qLang != ELanguageLabel.EN) {
    all.push(i18n.appendTranslations(qLang as TLanguage));
  } else {
    all.push(Promise.resolve(true));
  }
  all.push(appInitializer(i18n, qToken, referer));

  return Promise.all(all).then(([_1, _2, state]) => state);
};

const appInitializer = (i18n: I18nService, qToken?: string, referer?: string): Promise<boolean> => {
  return new Promise((resolve) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    const queryParams: Record<string, string | null> = {
      referer,
      [EQueryParam.TOKEN]: null,
      [EQueryParam.LANG]: null,
    };
    if (!auth.authToken()) {
      if (location.pathname?.startsWith(`/${EEndpointApp.Auth}`)) {
        return resolve(true);
      }

      if (!qToken) {
        resolve(true);
        return router.navigate([EEndpointApp.AUTH_SIGN_IN], {queryParams});
      }

      if (/^\d+\|[a-zA-Z\d]{30,60}$/g.test(qToken)) {
        auth.saveToken(qToken);
      }
    }
    lastValueFrom(auth.getProfile(), {defaultValue: null})
      .then((value: IAuth) => {
        if (value?.user?.language && value.user.language != i18n.getDefaultLang()) {
          i18n
            .setDefaultLang(value.user.language)
            .then(() => resolve(true))
            .catch(() => resolve(true));
        } else {
          resolve(true);
        }
        queryParams['referer'] = null;
        // return router.navigate(['.'], { queryParams });
      })
      .catch(() => {
        resolve(true);
        return router.navigate([EEndpointApp.AUTH_SIGN_IN], {queryParams});
      });
  });
};

const getParam = () => {
  const querySearch = new URLSearchParams(location.search || '');

  return {
    qLang: querySearch.get(EQueryParam.LANG),
    qToken: querySearch.get(EQueryParam.TOKEN),
    languageStorage: (localStorage.getItem('language') as TLanguage) ?? ELanguageLabel.EN,
    referer: encodeURIComponent(location.pathname),
  };
};
